/* Public source reviews only. No invented reviewer avatar or purchase-verification claim. */
(function (global) {
  'use strict';
  var MEDIA_HOSTS = new Set(['m.media-amazon.com', 'mms.img.susercontent.com', 'down-bs-br.vod.susercontent.com', 'down-zl-br.vod.susercontent.com', 'down-tx-br.vod.susercontent.com', 'down-ws-br.vod.susercontent.com', 'down-aka-br.vod.susercontent.com']);
  var ORIGINS = ['Amazon', 'Shopee'];
  var PAGE_LIMIT = 100;
  var DISPLAY_STEP = 8;
  var handlePattern = /^[a-z0-9][a-z0-9-]{0,200}$/;
  var int = function (value, minimum, maximum) { return Number.isInteger(value) && value >= minimum && value <= maximum; };
  var sum = function (values) { return values.reduce(function (a, b) { return a + b; }, 0); };
  var equal = function (a, b) { return a.length === b.length && a.every(function (value, i) { return value === b[i]; }); };

  function safeMediaURL(value) {
    if (typeof value !== 'string' || value.length > 3000) return null;
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || !MEDIA_HOSTS.has(url.hostname) || url.username || url.password || url.search || url.hash) return null;
      return url.href;
    } catch (_) { return null; }
  }
  function safeAvatarURL(value) {
    var clean = safeMediaURL(value);
    if (!clean) return null;
    try {
      var url = new URL(clean), path = decodeURIComponent(url.pathname);
      if (url.hostname !== 'm.media-amazon.com' || (url.port && url.port !== '443') || !/^\/images\/S\/amazon-avatars-global\/[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}(?:\.[A-Za-z0-9_,-]+)?\.(?:jpe?g|png|webp)$/i.test(path) || /default|placeholder|grey-pixel|gray-pixel|transparent/i.test(path)) return null;
      return clean;
    } catch (_) { return null; }
  }
  function safeSourceURL(value) {
    if (typeof value !== 'string') return null;
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || !['www.amazon.com.br', 'amazon.com.br'].includes(url.hostname) || url.username || url.password || !url.pathname.includes('/customer-reviews/')) return null;
      return url.href;
    } catch (_) { return null; }
  }
  function validDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    var parsed = new Date(value + 'T12:00:00Z');
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
  }
  function formatDate(value) {
    return validDate(value) ? value.slice(8, 10) + '/' + value.slice(5, 7) + '/' + value.slice(0, 4) : '';
  }
  function validFacets(value) {
    if (!value || typeof value !== 'object') return false;
    return ORIGINS.every(function (origin) {
      var item = value[origin];
      return item && ['all', 'media'].every(function (key) { return Array.isArray(item[key]) && item[key].length === 5 && item[key].every(function (n) { return int(n, 0, 100000); }); }) && item.media.every(function (n, i) { return n <= item.all[i]; });
    });
  }
  function facetCount(facets, filters) {
    var selected = filters.origin === 'all' ? ORIGINS : [filters.origin];
    return selected.reduce(function (total, origin) {
      var bins = facets[origin][filters.media ? 'media' : 'all'];
      return total + (filters.rating ? bins[filters.rating - 1] : sum(bins));
    }, 0);
  }
  function validateManifest(value, handle, productId) {
    if (!value || value.version !== 1 || value.identityVerified !== true || value.handle !== handle || value.productId !== productId || !handlePattern.test(handle) || !/^\d+$/.test(productId)) return null;
    if (!['matched_reviews', 'safe_sku_api_zero_returned', 'safe_sku_no_assigned_reviews', 'no_safe_source_sku', 'excluded_test', 'not_collected'].includes(value.coverageState)) return null;
    var summary = value.summary;
    if (!summary || !int(summary.total, 0, 100000) || !int(summary.ratingSum, 0, 500000) || !Array.isArray(summary.distribution) || summary.distribution.length !== 5 || !summary.distribution.every(function (n) { return int(n, 0, 100000); }) || !validFacets(summary.facets)) return null;
    if (sum(summary.distribution) !== summary.total || summary.distribution.reduce(function (total, n, i) { return total + n * (i + 1); }, 0) !== summary.ratingSum) return null;
    if (!equal(summary.distribution, ORIGINS.reduce(function (result, origin) { return result.map(function (n, i) { return n + summary.facets[origin].all[i]; }); }, [0, 0, 0, 0, 0]))) return null;
    if (!Array.isArray(value.pages) || value.pages.length > 1000 || (summary.total > 0 && !value.pages.length)) return null;
    var filenames = new Set();
    var aggregate = {Amazon: {all: [0, 0, 0, 0, 0], media: [0, 0, 0, 0, 0]}, Shopee: {all: [0, 0, 0, 0, 0], media: [0, 0, 0, 0, 0]}};
    var pagesValid = value.pages.every(function (page, index) {
      var expected = 'decolab-reviews-' + productId + '-20261001-p' + String(index + 1).padStart(3, '0') + '.json';
      if (!page || page.page !== index + 1 || page.asset !== expected || typeof page.revision !== 'string' || !/^[a-f0-9]{64}$/.test(page.revision) || filenames.has(page.asset) || !int(page.count, 1, PAGE_LIMIT) || !validFacets(page.facets) || facetCount(page.facets, {origin: 'all', media: false, rating: 0}) !== page.count) return false;
      filenames.add(page.asset);
      ORIGINS.forEach(function (origin) { ['all', 'media'].forEach(function (key) { aggregate[origin][key] = aggregate[origin][key].map(function (n, i) { return n + page.facets[origin][key][i]; }); }); });
      return true;
    });
    if (!pagesValid || sum(value.pages.map(function (p) { return p.count; })) !== summary.total || !ORIGINS.every(function (origin) { return equal(aggregate[origin].all, summary.facets[origin].all) && equal(aggregate[origin].media, summary.facets[origin].media); })) return null;
    return value;
  }
  function validateReview(value) {
    if (!value || !ORIGINS.includes(value.origin) || typeof value.id !== 'string' || !value.id.startsWith(value.origin + ':') || value.id.length > 100 || !int(value.rating, 1, 5) || !validDate(value.date)) return null;
    if (typeof value.name !== 'string' || value.name.length > 500 || typeof value.body !== 'string' || value.body.length > 50000) return null;
    if (!Array.isArray(value.photos) || !Array.isArray(value.videos) || !Array.isArray(value.variants) || value.photos.length > 50 || value.videos.length > 20 || !value.variants.every(function (v) { return typeof v === 'string' && v.length < 2000; })) return null;
    var photos = value.photos.map(safeMediaURL), videos = value.videos.map(safeMediaURL);
    if (photos.some(function (u) { return !u; }) || videos.some(function (u) { return !u; })) return null;
    var sourceUrl = value.sourceUrl ? safeSourceURL(value.sourceUrl) : null;
    if (value.sourceUrl && (!sourceUrl || value.origin !== 'Amazon')) return null;
    var avatarURL = value.origin === 'Amazon' ? safeAvatarURL(value.avatarURL) : null;
    return {id: value.id, origin: value.origin, name: value.name || 'Cliente', rating: value.rating, date: value.date, body: value.body, photos: photos, videos: videos, variants: value.variants, sourceUrl: sourceUrl, isExcerpt: value.isExcerpt === true, avatarURL: avatarURL};
  }
  function validatePage(value, manifest, meta) {
    if (!value || value.version !== 1 || value.handle !== manifest.handle || value.productId !== manifest.productId || value.page !== meta.page || !Array.isArray(value.reviews) || value.reviews.length !== meta.count) return null;
    var ids = new Set(), normalized = [];
    var facets = {Amazon: {all: [0, 0, 0, 0, 0], media: [0, 0, 0, 0, 0]}, Shopee: {all: [0, 0, 0, 0, 0], media: [0, 0, 0, 0, 0]}};
    for (var review of value.reviews) {
      var clean = validateReview(review);
      if (!clean || ids.has(clean.id)) return null;
      ids.add(clean.id); normalized.push(clean);
      facets[clean.origin].all[clean.rating - 1] += 1;
      if (clean.photos.length || clean.videos.length) facets[clean.origin].media[clean.rating - 1] += 1;
    }
    if (!ORIGINS.every(function (origin) { return equal(facets[origin].all, meta.facets[origin].all) && equal(facets[origin].media, meta.facets[origin].media); })) return null;
    return normalized;
  }
  function matchesReview(review, filters) {
    return (filters.origin === 'all' || review.origin === filters.origin) && (!filters.rating || review.rating === filters.rating) && (!filters.media || review.photos.length > 0 || review.videos.length > 0);
  }
  function selectCandidatePages(manifest, filters) {
    // Prioritize matching media using audited page facets, without fetching the
    // whole feed or giving any rating/origin preference. Ties keep source order.
    var mediaFilters = {origin: filters.origin, rating: filters.rating, media: true};
    return manifest.pages.filter(function (page) { return facetCount(page.facets, filters) > 0; })
      .map(function (page, index) { return {page: page, index: index, mediaCount: facetCount(page.facets, mediaFilters)}; })
      .sort(function (a, b) { return b.mediaCount - a.mediaCount || a.index - b.index; })
      .map(function (item) { return item.page; });
  }
  function reviewContentRank(review) {
    return review.photos.length || review.videos.length ? 0 : review.body.trim() ? 1 : 2;
  }
  function orderPageReviews(reviews) {
    // Each page has a stable content-first order. Do not globally re-sort the
    // loaded prefix: later pages must never push previously displayed rows out.
    return reviews.map(function (review, index) { return {review: review, index: index, rank: reviewContentRank(review)}; })
      .sort(function (a, b) { return a.rank - b.rank || a.index - b.index; })
      .map(function (item) { return item.review; });
  }
  function element(tag, className, text) {
    var node = global.document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function renderCard(review, openPhoto) {
    var ratingOnly = reviewContentRank(review) === 2;
    var card = element('article', 'dc-genuine-review' + (ratingOnly ? ' dc-genuine-review--rating-only' : ''));
    var header = element('header', 'dc-genuine-review__header');
    var identity = element('div', 'dc-genuine-review__identity');
    identity.append(element('strong', 'dc-genuine-review__name', review.name));
    var meta = element('div', 'dc-genuine-review__meta');
    meta.append(element('span', 'dc-genuine-review__origin', review.origin));
    var time = element('time', '', formatDate(review.date)); time.dateTime = review.date; meta.append(time); identity.append(meta);
    var stars = element('span', 'dc-genuine-review__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
    stars.setAttribute('aria-label', review.rating + ' de 5 estrelas');
    var avatarURL = review.origin === 'Amazon' ? safeAvatarURL(review.avatarURL) : null;
    if (avatarURL) {
      var author = element('div', 'dc-genuine-review__author');
      var avatar = element('img', 'dc-genuine-review__avatar');
      avatar.src = avatarURL; avatar.alt = ''; avatar.width = 36; avatar.height = 36;
      avatar.loading = 'lazy'; avatar.decoding = 'async'; avatar.referrerPolicy = 'no-referrer';
      avatar.addEventListener('error', function () { avatar.remove(); }, {once: true});
      author.append(avatar, identity); header.append(author, stars);
    } else header.append(identity, stars);
    card.append(header);
    if (review.isExcerpt && review.body.trim()) card.append(element('p', 'dc-genuine-review__excerpt', 'Trecho da avaliação'));
    if (review.body.trim()) card.append(element('p', 'dc-genuine-review__body', review.body));
    if (review.variants.length) card.append(element('p', 'dc-genuine-review__variant', review.variants.join(' · ')));
    if (review.photos.length || review.videos.length) {
      var media = element('div', 'dc-genuine-review__media');
      review.photos.forEach(function (url, index) {
        var button = element('button', 'dc-genuine-review__photo'); button.type = 'button';
        button.setAttribute('aria-label', 'Ampliar foto ' + (index + 1) + ' da avaliação de ' + review.name);
        var image = element('img'); image.src = url; image.alt = 'Foto enviada nesta avaliação'; image.loading = 'lazy'; image.decoding = 'async'; image.width = 88; image.height = 88;
        image.addEventListener('error', function () { button.hidden = true; }, {once: true});
        button.append(image); button.addEventListener('click', function () { openPhoto(url, review.name, button); }); media.append(button);
      });
      review.videos.forEach(function (url) {
        var video = element('video', 'dc-genuine-review__video'); video.controls = true; video.autoplay = false; video.preload = 'none'; video.playsInline = true; video.dataset.lazySrc = url;
        video.setAttribute('aria-label', 'Vídeo enviado nesta avaliação'); media.append(video);
      });
      card.append(media);
    }
    if (review.sourceUrl) {
      var source = element('a', 'dc-genuine-review__source', 'Ver na Amazon'); source.href = review.sourceUrl; source.target = '_blank'; source.rel = 'noopener noreferrer nofollow'; card.append(source);
    }
    return card;
  }
  async function fetchJSON(url) {
    var controller = new AbortController();
    var timeout = global.setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await global.fetch(url, {credentials: 'omit', signal: controller.signal, cache: 'default'});
      if (!response.ok) throw new Error('Feed unavailable');
      var text = await response.text();
      if (text.length > 1000000) throw new Error('Feed too large');
      return JSON.parse(text);
    } finally { global.clearTimeout(timeout); }
  }
  function createWidget(root) {
    if (root.dataset.ready || global.document.body.dataset.commerceChannel === 'b2b') return;
    root.dataset.ready = 'true';
    var handle = root.dataset.productHandle, productId = root.dataset.productId;
    var manifestURL;
    try {
      manifestURL = new URL(root.dataset.feedUrl, global.location.href);
      var sameSite = manifestURL.origin === global.location.origin;
      if (manifestURL.protocol !== 'https:' || manifestURL.username || manifestURL.password || (!sameSite && manifestURL.hostname !== 'cdn.shopify.com') || !manifestURL.pathname.endsWith('decolab-reviews-' + productId + '-20261001-manifest.json')) return;
    } catch (_) { return; }
    var state = {manifest: null, cache: new Map(), limit: DISPLAY_STEP, serial: 0, valid: false, loading: false, destroyed: false};
    var list = root.querySelector('[data-review-list]'), status = root.querySelector('[data-review-status]'), more = root.querySelector('[data-review-more]');
    var originControl = root.querySelector('[data-review-origin]'), ratingControl = root.querySelector('[data-review-rating]'), mediaControl = root.querySelector('[data-review-media]');
    var dialog = root.querySelector('[data-review-dialog]'), fullImage = root.querySelector('[data-review-full-image]'), dialogTitle = root.querySelector('[data-review-dialog-title]'), close = root.querySelector('[data-review-close]');
    var returnFocus = null, legacyObserver = null, summaryLink = null, summarySlot = null, summarySlotWasHidden = false;
    var filters = function () { return {origin: originControl.value, rating: Number(ratingControl.value), media: mediaControl.checked}; };
    function closePhoto() {
      if (dialog.open && typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
      fullImage.removeAttribute('src');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll: true});
      returnFocus = null;
    }
    function openPhoto(url, name, button) {
      if (!safeMediaURL(url)) return;
      returnFocus = button; fullImage.src = url; fullImage.alt = 'Foto enviada na avaliação de ' + name; dialogTitle.textContent = 'Foto da avaliação de ' + name;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else { dialog.setAttribute('open', ''); dialog.setAttribute('aria-modal', 'true'); }
      close.focus({preventScroll: true});
    }
    close.addEventListener('click', closePhoto);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); closePhoto(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closePhoto(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); closePhoto(); }
      if (event.key === 'Tab') { event.preventDefault(); close.focus(); }
    });
    var lazyVideos = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { var video = entry.target; video.src = video.dataset.lazySrc; delete video.dataset.lazySrc; lazyVideos.unobserve(video); } });
    }, {rootMargin: '120px'}) : null;
    function observeMedia() {
      list.querySelectorAll('video[data-lazy-src]').forEach(function (video) { if (lazyVideos) lazyVideos.observe(video); else { video.src = video.dataset.lazySrc; delete video.dataset.lazySrc; } });
    }
    function clearCards() {
      list.querySelectorAll('video').forEach(function (video) { video.pause(); video.removeAttribute('src'); video.load(); });
      if (lazyVideos) lazyVideos.disconnect();
      list.replaceChildren();
    }
    function averageText() { return (state.manifest.summary.ratingSum / state.manifest.summary.total).toLocaleString('pt-BR', {minimumFractionDigits: 1, maximumFractionDigits: 1}); }
    function replaceLegacy() {
      if (!state.valid) return;
      var star = global.document.querySelector('#auto-bk-star-section');
      if (!summarySlot) {
        summarySlot = global.document.querySelector('[data-dc-review-summary-slot]');
        if (summarySlot) summarySlotWasHidden = summarySlot.hidden;
      }
      if (summarySlot) summarySlot.hidden = state.manifest.summary.total === 0;
      if ((summarySlot || star) && !summaryLink && state.manifest.summary.total > 0) {
        summaryLink = element('a', 'dc-genuine-review-summary', '★ ' + averageText() + ' · ' + state.manifest.summary.total.toLocaleString('pt-BR') + ' avaliações');
        summaryLink.href = '#' + root.id; summaryLink.setAttribute('data-dc-genuine-summary', '');
        if (summarySlot) summarySlot.append(summaryLink); else star.before(summaryLink);
      }
      global.document.querySelectorAll('#auto-bk-star-section').forEach(function (node) { node.setAttribute('data-dc-genuine-replaced', 'true'); });
      if (state.manifest.summary.total > 0 && !root.hidden) {
        global.document.querySelectorAll('#auto-bk-review-section').forEach(function (node) { node.setAttribute('data-dc-genuine-replaced', 'true'); });
      }
    }
    function renderHeader() {
      var summary = state.manifest.summary;
      root.querySelector('[data-review-average]').textContent = averageText();
      root.querySelector('[data-review-total]').textContent = summary.total.toLocaleString('pt-BR') + ' avaliações disponíveis';
      var sources = ORIGINS.filter(function (origin) { return sum(summary.facets[origin].all) > 0; });
      root.querySelector('[data-review-provenance]').textContent = 'Avaliações publicadas na ' + sources.join(' e ') + ' para este produto.';
      root.querySelectorAll('[data-review-distribution]').forEach(function (bar) {
        var rating = Number(bar.dataset.reviewDistribution), count = summary.distribution[rating - 1];
        bar.value = count; bar.max = summary.total; bar.setAttribute('aria-label', rating + ' estrelas: ' + count + ' avaliações');
        bar.parentElement.querySelector('[data-review-distribution-count]').textContent = count.toLocaleString('pt-BR');
      });
      ORIGINS.forEach(function (origin) { var option = originControl.querySelector('option[value="' + origin + '"]'); if (option) option.disabled = sum(summary.facets[origin].all) === 0; });
    }
    async function getPage(meta) {
      if (!state.cache.has(meta.asset)) {
        var pageURL = new URL(meta.asset, manifestURL);
        pageURL.searchParams.set('v', meta.revision);
        var request = fetchJSON(pageURL.href).then(function (json) {
          var reviews = validatePage(json, state.manifest, meta);
          if (!reviews) throw new Error('Invalid review page');
          return reviews;
        }).catch(function (error) { state.cache.delete(meta.asset); throw error; });
        state.cache.set(meta.asset, request);
      }
      return state.cache.get(meta.asset);
    }
    async function render() {
      var serial = ++state.serial, query = filters();
      var total = facetCount(state.manifest.summary.facets, query), candidates = selectCandidatePages(state.manifest, query), rows = [], ids = new Set();
      state.loading = true; more.disabled = true; list.setAttribute('aria-busy', 'true'); status.textContent = 'Carregando avaliações…';
      try {
        for (var meta of candidates) {
          var page = await getPage(meta);
          if (serial !== state.serial) return;
          for (var review of orderPageReviews(page)) {
            if (ids.has(review.id)) throw new Error('Duplicate across review pages');
            ids.add(review.id);
            if (matchesReview(review, query)) rows.push(review);
          }
          if (rows.length >= state.limit) break;
        }
        if (serial !== state.serial) return;
        clearCards();
        var fragment = global.document.createDocumentFragment();
        rows.slice(0, state.limit).forEach(function (review) { fragment.append(renderCard(review, openPhoto)); });
        list.replaceChildren(fragment); observeMedia();
        var shown = Math.min(rows.length, state.limit);
        status.textContent = total ? shown.toLocaleString('pt-BR') + ' de ' + total.toLocaleString('pt-BR') + ' avaliações' : 'Nenhuma avaliação com estes filtros.';
        more.hidden = shown >= total; more.textContent = 'Ver mais avaliações';
        if (more.hidden && global.document.activeElement === more) status.focus({preventScroll: true});
      } catch (_) {
        if (serial === state.serial) { status.textContent = 'Não foi possível carregar mais avaliações. Tente novamente.'; more.hidden = false; more.textContent = 'Tentar novamente'; }
      } finally {
        if (serial === state.serial) { state.loading = false; more.disabled = false; list.setAttribute('aria-busy', 'false'); }
      }
    }
    [originControl, ratingControl, mediaControl].forEach(function (control) { control.addEventListener('change', function () { state.limit = DISPLAY_STEP; clearCards(); render(); }); });
    more.addEventListener('click', function () { if (state.loading) return; if (more.textContent !== 'Tentar novamente') state.limit += DISPLAY_STEP; render(); });
    async function loadInitial() {
      try {
        var json = await fetchJSON(manifestURL.href);
        var manifest = validateManifest(json, handle, productId);
        if (!manifest || state.destroyed || !root.isConnected) return;
        state.manifest = manifest;
        // An audited identity with no collected reviews hides unverified legacy counts only.
        // It does not assert that the product has no reviews anywhere.
        if (manifest.summary.total === 0) {
          state.valid = true; root.dataset.feedValid = 'true'; replaceLegacy();
          legacyObserver = new MutationObserver(replaceLegacy);
          legacyObserver.observe(global.document.body, {childList: true, subtree: true});
          return;
        }
        // Validate the page that will actually lead the initial results. A
        // filter with no results still validates one source page for fallback.
        await getPage(selectCandidatePages(manifest, filters())[0] || manifest.pages[0]);
        if (state.destroyed || !root.isConnected) return;
        state.valid = true; root.hidden = false; root.dataset.feedValid = 'true'; renderHeader(); replaceLegacy();
        legacyObserver = new MutationObserver(replaceLegacy);
        legacyObserver.observe(global.document.body, {childList: true, subtree: true});
        render();
      } catch (_) { root.dataset.feedValid = 'false'; /* BK stays visible when the feed is missing or invalid. */ }
    }
    // Delay network work until the page has settled; remaining pages and media are incremental.
    if (typeof global.requestIdleCallback === 'function') global.requestIdleCallback(loadInitial, {timeout: 1200}); else global.setTimeout(loadInitial, 400);
    global.document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      state.destroyed = true;
      state.serial += 1;
      if (legacyObserver) legacyObserver.disconnect();
      if (lazyVideos) lazyVideos.disconnect();
      if (summaryLink) summaryLink.remove();
      if (summarySlot) summarySlot.hidden = summarySlotWasHidden;
      global.document.querySelectorAll('[data-dc-genuine-replaced]').forEach(function (node) { node.removeAttribute('data-dc-genuine-replaced'); });
      closePhoto();
    });
  }
  var API = {safeMediaURL: safeMediaURL, safeAvatarURL: safeAvatarURL, safeSourceURL: safeSourceURL, validDate: validDate, formatDate: formatDate, validateManifest: validateManifest, validateReview: validateReview, validatePage: validatePage, matchesReview: matchesReview, facetCount: facetCount, selectCandidatePages: selectCandidatePages, reviewContentRank: reviewContentRank, orderPageReviews: orderPageReviews, renderCard: renderCard, createWidget: createWidget};
  if (typeof module === 'object' && module.exports) module.exports = API;
  if (!global.document) return;
  var init = function () { global.document.querySelectorAll('[data-genuine-reviews]').forEach(createWidget); };
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  global.document.addEventListener('shopify:section:load', init);
})(typeof window !== 'undefined' ? window : globalThis);
